import { cva } from 'class-variance-authority';
import type { PillColorsEnum } from '../types';

const dotVariants = cva('w-md h-md rounded-full', {
  variants: {
    variant: {
      soft: '',
      clear: '',
      solid: '!bg-primary',
    },
    color: {
      gray: 'bg-utility-gray-500',
      brand: 'bg-utility-brand-500',
      error: 'bg-utility-error-500',
      warning: 'bg-utility-warning-500',
      success: 'bg-utility-success-500',
      blue: 'bg-utility-blue-500',
      purple: 'bg-utility-purple-500',
      fuchsia: 'bg-utility-fuchsia-500',
      cyan: 'bg-utility-cyan-500',
      lime: 'bg-utility-lime-500',
      pink: 'bg-utility-pink-500',
      violet: 'bg-utility-violet-500',
      indigo: 'bg-utility-indigo-500',
      rose: 'bg-utility-rose-500',
      yellow: 'bg-utility-warning-300',
    } satisfies Record<PillColorsEnum, string>,
  },
  compoundVariants: [
    { variant: 'soft', color: 'gray', className: 'bg-utility-gray-500' },
    { variant: 'soft', color: 'brand', className: 'bg-utility-brand-500' },
    { variant: 'soft', color: 'error', className: 'bg-utility-error-500' },
    { variant: 'soft', color: 'warning', className: 'bg-utility-warning-500' },
    { variant: 'soft', color: 'success', className: 'bg-utility-success-500' },
    { variant: 'soft', color: 'blue', className: 'bg-utility-blue-500' },
    { variant: 'soft', color: 'purple', className: 'bg-utility-purple-500' },
    { variant: 'soft', color: 'fuchsia', className: 'bg-utility-fuchsia-500' },
    { variant: 'soft', color: 'cyan', className: 'bg-utility-cyan-500' },
    { variant: 'soft', color: 'lime', className: 'bg-utility-lime-500' },
    { variant: 'soft', color: 'pink', className: 'bg-utility-pink-500' },
    { variant: 'soft', color: 'violet', className: 'bg-utility-violet-500' },
    { variant: 'soft', color: 'indigo', className: 'bg-utility-indigo-500' },
    { variant: 'soft', color: 'rose', className: 'bg-utility-rose-500' },
    { variant: 'clear', color: 'gray', className: 'bg-utility-gray-500' },
    { variant: 'clear', color: 'brand', className: 'bg-utility-brand-500' },
    { variant: 'clear', color: 'error', className: 'bg-utility-error-500' },
    { variant: 'clear', color: 'warning', className: 'bg-utility-warning-500' },
    { variant: 'clear', color: 'success', className: 'bg-utility-success-500' },
    { variant: 'clear', color: 'blue', className: 'bg-utility-blue-500' },
    { variant: 'clear', color: 'purple', className: 'bg-utility-purple-500' },
    { variant: 'clear', color: 'fuchsia', className: 'bg-utility-fuchsia-500' },
    { variant: 'clear', color: 'cyan', className: 'bg-utility-cyan-500' },
    { variant: 'clear', color: 'lime', className: 'bg-utility-lime-500' },
    { variant: 'clear', color: 'pink', className: 'bg-utility-pink-500' },
    { variant: 'clear', color: 'violet', className: 'bg-utility-violet-500' },
    { variant: 'clear', color: 'indigo', className: 'bg-utility-indigo-500' },
    { variant: 'clear', color: 'rose', className: 'bg-utility-rose-500' },
  ],
});

export default dotVariants;
